import { render, staticRenderFns } from "./MarkList.vue?vue&type=template&id=d439ac24&scoped=true&"
import script from "./MarkList.vue?vue&type=script&lang=js&"
export * from "./MarkList.vue?vue&type=script&lang=js&"
import style0 from "./MarkList.vue?vue&type=style&index=0&id=d439ac24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d439ac24",
  null
  
)

export default component.exports